import { environment } from "@enviroments/environment";
import { CommonUtils } from "./common.util";
import { AuthUtil } from "./auth.util";

export class ParameterUtils {

    static getPdtWishListParams(cateCd : string, key : string, len : number, page : number, pathKind : string) {
        return {
            cateCd : cateCd,
            comId : environment.comId,
            key : key,
            len : len,
            page : page, 
            pathKind : pathKind,
            userid : AuthUtil.getLoginedInfo()?.userid
        }
    }
}